import { GLOBAL_LIST_ACTION_SCOPE } from "containers/Resources/listActionScope";

export const actions = {
    START_DELETE_RESOURCE: "START_DELETE_RESOURCE",
    START_DELETE_RESOURCES: "START_DELETE_RESOURCES",
    DELETE_RESOURCE_SUCCESSFUL: "DELETE_RESOURCE_SUCCESSFUL",
    DELETE_RESOURCE_FAILED: "DELETE_RESOURCE_FAILED",

    START_PERMANENTLY_DELETE_RESOURCE: "START_PERMANENTLY_DELETE_RESOURCE",
    START_PERMANENTLY_DELETE_RESOURCES: "START_PERMANENTLY_DELETE_RESOURCES",
    PERMANENTLY_DELETE_RESOURCE_SUCCESSFUL: "PERMANENTLY_DELETE_RESOURCE_SUCCESSFUL",
    PERMANENTLY_DELETE_RESOURCE_FAILED: "PERMANENTLY_DELETE_RESOURCE_FAILED",

    START_UNDELETE_RESOURCE: "START_UNDELETE_RESOURCE",
    START_UNDELETE_RESOURCES: "START_UNDELETE_RESOURCES",
    UNDELETE_RESOURCE_SUCCESSFUL: "UNDELETE_RESOURCE_SUCCESSFUL",
    UNDELETE_RESOURCE_FAILED: "UNDELETE_RESOURCE_FAILED",

    START_MIGRATE_DEPRECATIONS: "START_MIGRATE_DEPRECATIONS",
    START_MIGRATE_DEPRECATIONS_RESOURCES: "START_MIGRATE_DEPRECATIONS_RESOURCES",

    STORE_RESOURCE_DATA_WITH_PARTIAL_UPDATE: "STORE_RESOURCE_DATA_WITH_PARTIAL_UPDATE",

    START_CREATE_RESOURCE: "START_CREATE_RESOURCE",
    CREATE_RESOURCE_SUCCESSFUL: "CREATE_RESOURCE_SUCCESSFUL",
    CREATE_RESOURCE_FAILED: "CREATE_RESOURCE_FAILED",

    START_IMPORT_RESOURCE: "START_IMPORT_RESOURCE",
    IMPORT_RESOURCE_SUCCESSFUL: "IMPORT_RESOURCE_SUCCESSFUL",
    IMPORT_RESOURCE_FAILED: "IMPORT_RESOURCE_FAILED",

    START_UPDATE_RESOURCE: "START_UPDATE_RESOURCE",
    START_UPDATE_RESOURCES: "START_UPDATE_RESOURCES",
    UPDATE_RESOURCE_SUCCESSFUL: "UPDATE_RESOURCE_SUCCESSFUL",
    UPDATE_RESOURCE_FAILED: "UPDATE_RESOURCE_FAILED",

    START_FETCHING_RESOURCE: "START_FETCHING_RESOURCE",
    FETCH_RESOURCE_SUCCESSFUL: "FETCH_RESOURCE_SUCCESSFUL",
    FETCH_RESOURCE_FAILED: "FETCH_RESOURCE_FAILED",

    START_CLOSING_RESOURCE: "START_CLOSING_RESOURCE",
    CLOSE_RESOURCE_SUCCESSFUL: "CLOSE_RESOURCE_SUCCESSFUL",
    CLOSE_RESOURCE_FAILED: "CLOSE_RESOURCE_FAILED",

    START_PINNING_RESOURCE: "START_PINNING_RESOURCE",
    PIN_RESOURCE_SUCCESSFUL: "PIN_RESOURCE_SUCCESSFUL",
    PIN_RESOURCE_FAILED: "PIN_RESOURCE_FAILED",

    START_UNPINNING_RESOURCE: "START_UNPINNING_RESOURCE",
    UNPIN_RESOURCE_SUCCESSFUL: "UNPIN_RESOURCE_SUCCESSFUL",
    UNPIN_RESOURCE_FAILED: "UNPIN_RESOURCE_FAILED",

    STORE_RESOURCE_DATA: "STORE_RESOURCE_DATA",
    CLEAR_RESOURCE_DATA: "CLEAR_RESOURCE_DATA",

    START_CREATE_CONNECTOR_VAULT_SECRET: "START_CREATE_CONNECTOR_VAULT_SECRET",
    CREATE_CONNECTOR_VAULT_SECRET_SUCCESSFUL: "CREATE_CONNECTOR_VAULT_SECRET_SUCCESSFUL",
    CREATE_CONNECTOR_VAULT_SECRET_FAILED: "CREATE_CONNECTOR_VAULT_SECRET_FAILED",

    START_FETCHING_VISUALIZATION: "START_FETCHING_VISUALIZATION",
    FETCH_VISUALIZATION_SUCCESSFUL: "FETCH_VISUALIZATION_SUCCESSFUL",
    FETCH_VISUALIZATION_FAILED: "FETCH_VISUALIZATION_FAILED",

    SUCCESSFUL_FETCH_LISTING_OBJECT_TEMPLATE_LIST: "SUCCESSFUL_FETCH_LISTING_OBJECT_TEMPLATE_LIST",

    STORE_TEMPORARY_RECORD_DATA: "STORE_TEMPORARY_RECORD_DATA",
    CLEAR_TEMPORARY_RECORD_DATA: "CLEAR_TEMPORARY_RECORD_DATA",

    LIST_ACTION_PROGRESS_UPDATE: "LIST_ACTION_PROGRESS_UPDATE",
    LIST_ACTION_PROGRESS_CLEAR: "LIST_ACTION_PROGRESS_CLEAR",
};

export const initialState = {
    listingFetching: false,
    listingResponse: {},
    singleFetching: [],
    temporaryRecordData: {},
    // Map of scopeId -> { current, total, label, scopeId }. Keyed so a bulk
    // action lights up only the acting table's toolbar; unscoped actions use
    // GLOBAL_LIST_ACTION_SCOPE (see listActionScope.ts).
    listActionProgress: {},
};

export default (
    state = initialState,
    { type, response, iri, temporaryKey, progress, scopeId }
) => {
    switch (type) {
        case actions.START_FETCHING_RESOURCE: {
            const newFetching = Array.from(state.singleFetching);
            newFetching.push(iri);
            return {
                ...state,
                singleFetching: newFetching,
            };
        }
        case actions.FETCH_RESOURCE_SUCCESSFUL: {
            return {
                ...state,
                singleFetching: state.singleFetching.filter((item) => item !== iri),
            };
        }
        case actions.FETCH_RESOURCE_FAILED: {
            return {
                ...state,
                singleFetching: state.singleFetching.filter((item) => item !== iri),
            };
        }
        case actions.STORE_RESOURCE_DATA: {
            return Object.assign({}, state, {
                [iri]: response,
            });
        }
        case actions.STORE_RESOURCE_DATA_WITH_PARTIAL_UPDATE: {
            // Only the updated entry needs a new identity; deep-cloning the whole cache
            // (which can hold large file-content blobs) forced app-wide re-renders on
            // every partial update.
            return {
                ...state,
                [iri]: { ...state[iri], ...response },
            };
        }
        case actions.CLEAR_RESOURCE_DATA: {
            const stateCopy = { ...state };
            delete stateCopy[iri];
            return stateCopy;
        }
        case actions.DELETE_RESOURCE_FAILED: {
            return state;
        }
        case actions.SUCCESSFUL_FETCH_LISTING_OBJECT_TEMPLATE_LIST: {
            return Object.assign({}, state, {
                objectTemplateList: response?.object_template_plain_list,
            });
        }

        case actions.STORE_TEMPORARY_RECORD_DATA: {
            return {
                ...state,
                temporaryRecordData: {
                    ...state.temporaryRecordData,
                    [temporaryKey]: response,
                },
            };
        }

        case actions.CLEAR_TEMPORARY_RECORD_DATA: {
            const temporaryDataCopy = { ...state.temporaryRecordData };
            delete temporaryDataCopy[temporaryKey];
            return {
                ...state,
                temporaryRecordData: temporaryDataCopy,
            };
        }

        case actions.LIST_ACTION_PROGRESS_UPDATE: {
            const key = progress?.scopeId || GLOBAL_LIST_ACTION_SCOPE;
            return {
                ...state,
                listActionProgress: {
                    ...state.listActionProgress,
                    [key]: progress,
                },
            };
        }

        case actions.LIST_ACTION_PROGRESS_CLEAR: {
            const key = scopeId || GLOBAL_LIST_ACTION_SCOPE;
            const nextProgress = { ...state.listActionProgress };
            delete nextProgress[key];
            return {
                ...state,
                listActionProgress: nextProgress,
            };
        }

        default:
            return state;
    }
};
